// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import BoxGradientBorder from '../../../../../components/BoxGradientBorder';
import BoomUIBySkinId from '../../../constants/ui';
import { useBoomContext } from '../../../contexts/BoomContext';

const StyledBoxGradientBorder = styled(BoxGradientBorder)`
  border-radius: 0.6em;
  padding: 0.6em;
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);

  ${({ $isSmall, $isSuccess, $skinId }) => {
    const boxStyle = BoomUIBySkinId[$skinId]?.BOX_STYLE[$isSuccess ? 'success' : 'default'] ?? {};
    return css`
      --BoxGradientBorder-width: ${boxStyle.borderWidth ?? 0}px;
      --BoxGradientBorder-gradient: ${$isSmall ? boxStyle.borderGradientSmall : boxStyle.borderGradient};
      --BoxGradientBorder-fallbackColor: ${boxStyle.borderColor};
      background-image: ${boxStyle.backgroundGradient};
    `;
  }}

  ${({ $isSmall }) =>
    !$isSmall
      ? css`
          border-radius: 1em;
        `
      : null}
`;

type BoomBoxWrapperProps = {
  className?: string;
  children: React.ReactNode;
  isSmall: boolean;
  isSuccess: boolean;
};

const BoomBoxWrapper = ({ className = '', children, isSmall = false, isSuccess = false }: BoomBoxWrapperProps) => {
  const { skinId } = useBoomContext();

  return (
    <StyledBoxGradientBorder className={className} $isSmall={isSmall} $isSuccess={isSuccess} $skinId={skinId}>
      {children}
    </StyledBoxGradientBorder>
  );
};

export default BoomBoxWrapper;
